<!-- CustomCard.vue -->
<template>
  <BCard class="customized-card" :class="cardClasses">
    <BCardHeader v-if="$slots.header || title || hasHeaderSlots" class="customized-card__header">
      <slot name="header">
        <!-- Default Header Structure mit Sub-Slots -->
        <div class="customized-card__header-content">
          <div class="customized-card__header-text">
            <div v-if="$slots['header-title'] || title" class="customized-card__header-title">
              <slot name="header-title">
                <h5 class="mb-0">{{ title }}</h5>
              </slot>
            </div>

            <div v-if="$slots['header-subtitle']" class="customized-card__header-subtitle">
              <slot name="header-subtitle"></slot>
            </div>
          </div>

          <div v-if="$slots['header-actions-top'] || $slots['header-actions-bottom']" class="customized-card__header-actions">
            <div v-if="$slots['header-actions-top']" class="customized-card__header-actions-row">
              <slot name="header-actions-top"></slot>
            </div>

            <div v-if="$slots['header-actions-bottom']" class="customized-card__header-actions-row">
              <slot name="header-actions-bottom"></slot>
            </div>
          </div>
        </div>
      </slot>
    </BCardHeader>

    <BCardBody class="customized-card__body">
      <div class="customized-card__scroll">
        <slot></slot>
      </div>
    </BCardBody>

    <BCardFooter v-if="$slots.footer" class="customized-card__footer">
      <slot name="footer"></slot>
    </BCardFooter>
  </BCard>
</template>

<script>
export default {
  name: 'CustomCard',

  props: {
    title: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'highlighted', 'minimal', 'primary', 'success', 'danger'].includes(val)
    },
    elevated: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    cardClasses() {
      return {
        [`customized-card--${this.variant}`]: this.variant !== 'default',
        'customized-card--elevated': this.elevated
      };
    },

    hasHeaderSlots() {
      return this.$slots['header-title'] ||
             this.$slots['header-subtitle'] ||
             this.$slots['header-actions-top'] ||
             this.$slots['header-actions-bottom'];
    }
  }
};
</script>

<style lang="scss">
.customized-card-noborder .card-body {
  padding: 0 !important;
}
.customized-card-noborder {
  border: none !important;
}
</style>

<style lang="scss" scoped>
.card-header {
  background-color: transparent;
}

.customized-card {
  border-radius: var(--radius-lg);
  background-color: none !important;
  // transition: all 0.3s ease;

  // Variants
  &--default {
    border: 1px solid var(--bs-border-color);
  }

  &--highlighted {
    border: 2px solid var(--bs-primary);
  }

  &--minimal {
    border: none;
  }

  &--primary {
    border-color: var(--bs-primary);

    .customized-card__header {
      // background-color: var(--bs-primary);
      color: white;
    }
  }

  &--success {
    border-color: var(--bs-success);

    .customized-card__header {
      // background-color: var(--bs-success);
      color: white;
    }
  }

  &--danger {
    border-color: var(--bs-danger);

    .customized-card__header {
      // background-color: var(--bs-danger);
      color: white;
    }
  }

  &--elevated {

    &:hover {
      transform: translateY(-2px);
    }
  }
}

.customized-card__header {
  // background-color: var(--bs-light);
  border-bottom: 0px solid var(--bs-border-color);
  font-weight: 600;
  padding: 0.25rem 0.25rem;
}

.customized-card__header-content {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.customized-card__header-text {
  flex: 1;
}

.customized-card__header-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 0.375rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  h5, h4, h3 {
    margin-bottom: 0;
    font-size: inherit;
    font-weight: inherit;
  }
}

.customized-card__header-subtitle {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
  color: var(--bs-secondary-color);
  margin-top: 0.25rem;
}

.customized-card__header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;

  @media (max-width: 1024px) {
    align-items: flex-start;
    width: 100%;
  }
}

.customized-card__header-actions-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: flex-start;
  }
}

.customized-card__title {
  color: inherit;
  font-size: 1.125rem;
}

.customized-card__body {
  padding: 0.25rem;
}

.customized-card__footer {
  // background-color: var(--bs-light);
  border-top: 1px solid var(--bs-border-color);
  padding: 0.25rem 0.25rem;
  font-size: 0.875rem;
}

.card.customized-card {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  /* ganz wichtig: kein min-width: max-content oder ähnliches hier */
}

/* Der Scroll-Container übernimmt das Überbreite-Handling */
.customized-card__scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

/* Die Spalten sollen nebeneinander bleiben und die Breite bestimmen */
.customized-card__scroll > * {
  display: inline-flex;      /* oder flex; */
  min-width: max-content;    /* Inhalt darf breiter als Card sein -> Scrollbar */
}
</style>
